import { render, staticRenderFns } from "./HomeTrendingCourses.vue?vue&type=template&id=0426272c&"
import script from "./HomeTrendingCourses.vue?vue&type=script&lang=js&"
export * from "./HomeTrendingCourses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports